import { type Static, Type } from "@sinclair/typebox"
import { IsoDateTimeSchema } from "./common"

// Agregados del dashboard [V1] — GET /admin/metrics?range=&bucket= y SSE
// /admin/metrics/stream (cada push del stream es un MetricsResponse parcial).

export const MetricsQuerySchema = Type.Object({
  // Ventana, ej. "1h", "24h", "7d" (default 24h)
  range: Type.Optional(Type.String()),
  // Granularidad, ej. "1m", "1h" (default según range)
  bucket: Type.Optional(Type.String()),
})
export type MetricsQuery = Static<typeof MetricsQuerySchema>

export const MetricsKpisSchema = Type.Object({
  // Usuarios autenticados ahora (familias de refresh activas con uso reciente)
  active_users: Type.Integer({ minimum: 0 }),
  logins_per_minute: Type.Number({ minimum: 0 }),
  // Logins fallidos en el último minuto (contador en Redis)
  logins_failed_per_minute: Type.Number({ minimum: 0 }),
  nodes_healthy: Type.Integer({ minimum: 0 }),
  nodes_total: Type.Integer({ minimum: 0 }),
  // Requests por segundo (media de la ventana reciente; contador en Redis)
  requests_per_second: Type.Number({ minimum: 0 }),
})
export type MetricsKpis = Static<typeof MetricsKpisSchema>

export const MetricSeriesPointSchema = Type.Object({
  ts: IsoDateTimeSchema,
  value: Type.Number(),
})
export type MetricSeriesPoint = Static<typeof MetricSeriesPointSchema>

export const MetricSeriesSchema = Type.Object({
  // Nombre del rollup, ej. "logins.success"
  metric: Type.String(),
  labels: Type.Optional(Type.Record(Type.String(), Type.String())),
  // Anchura del bucket de cada punto en segundos (60 para por-minuto, 1 para RPS);
  // permite al dashboard rotular y espaciar el histograma sin adivinar.
  interval_seconds: Type.Optional(Type.Integer({ minimum: 1 })),
  points: Type.Array(MetricSeriesPointSchema),
})
export type MetricSeries = Static<typeof MetricSeriesSchema>

export const MetricsResponseSchema = Type.Object({
  range: Type.String(),
  bucket: Type.String(),
  kpis: MetricsKpisSchema,
  series: Type.Array(MetricSeriesSchema),
})
export type MetricsResponse = Static<typeof MetricsResponseSchema>
